export default __webpack_public_path__ + "static/media/analytics-icon.153e9236.png";